export enum PaymentCode {
  Offline = 'Offline',
  CreditCard = 'CC',
}
